
export default class BasketChanges
{
    constructor({ rootNode })
    {
        this.rootNode = rootNode;

        this.bindEvents();
        this.init();
    }

    init()
    {
        if (this.getEntity('form')) {
            this.validateSubscribeButton();
        }

        $(this.rootNode).on('show.bs.modal', () => {
            $(this.rootNode).one('transitionstart', () => {
                this.getAllEntities('basket-changes-slider')
                    .forEach(sliderNode => {this.initSlider(sliderNode)})
            });
        });

        $(this.rootNode).modal('show');
    }

    bindEvents()
    {
        this.getAllEntities('subscribe-to-product')
            .forEach(button => button.addEventListener('click', e => this.handleSubscribeToProduct(button, e)));

        this.getAllEntities('subscribe-form')
            .forEach(form => form.addEventListener('submit', e => this.handleSubscribeForm(form, e)))

        this.getAllEntities('subscribtion-toggle')
            .forEach(button => button.addEventListener('click', () => setTimeout(() => this.validateSubscribeButton(), 100)));

        this.rootNode.querySelectorAll('input[name="email"]')
            .forEach(input => input.addEventListener('input', () => setTimeout(() => this.validateSubscribeButton(), 100)))
    }

    initSlider(sliderNode)
    {
        if (sliderNode.classList.contains('slick-initialized')) {
            $(sliderNode).slick('setPosition');
            return;
        }

        $(sliderNode).slick({
            dots: false,
            arrows: true,
            infinite: false, 
            speed: 300,
            slidesToShow: 3,
            responsive: [
                {
                    breakpoint: 360,
                    settings: {
                        slidesToShow: 1
                    },
                },
                {
                    breakpoint: MOBILE_BREAKPOINT,
                    settings: {
                        slidesToShow: 2
                    },
                },
            ],
        });
    }

    validateSubscribeButton()
    {
        const email = this.rootNode.querySelector('input[name="email"]').value;

        const button = this.getEntity('subscribe-submit');
        const activeSubscriptionToggle = this.getAllEntities('subscribtion-toggle')
            .find(buttonNode => buttonNode.classList.contains('active'));

        if (email.trim().length != '' && activeSubscriptionToggle) {
            button.disabled = false;
            button.classList.remove('disabled');
        } else {
            button.disabled = true;
            button.classList.add('disabled');
        }
    }

    handleSubscribeForm(context, event)
    {
        event.preventDefault();

        const email = context.querySelector('input[name="email"]').value;

        const products = this.getAllEntities('subscribtion-toggle')
            .filter(buttonNode => buttonNode.classList.contains('active'))
            .map(buttonNode => ({
                id: buttonNode.dataset.id,
                offerId: buttonNode.dataset.offerId
            }));

        this.subscribe(products, email)
            .then(res => {
                this.processSubscribeResponse(res);
                products.forEach(({ id, offerId }) => {
                    BX.Event.EventEmitter.emit(
                        'Mario.Card:subscribed', 
                        { id, email, offer_id: offerId, source: 'basket' }
                    );
                });
            });
    }

    subscribe(products, email)
    {
        return $.post('/ajax/subscribe/product_multiple/', { products, email }, null, 'json')
            .then(res => {
                if (res.type !== 'success') {
                    throw new Error(res.error);
                }

                return res;
            });
    }

    processSubscribeResponse(res)
    {
        if (res.type != 'success') {
            console.error(res);
            return;
        }

        const contentNode = this.rootNode.querySelector('.modal-content');
        contentNode.style.height = `${contentNode.clientHeight}px`;

        BX.Dom.replace(
            contentNode.querySelector('.modal-body'),
            BX.Tag.render`
                <div class="modal-body">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                        <span class="close-icon close-icon__black"></span>
                    </button>
                    <h4 class="modal-title">Отлично! Уведомим вас о поступлении </h4>
                    <div class="modal-description">
                        Как только товар поступит в продажу, мы пришлем вам уведомление на e-mail. 
                        Посмотреть товары, на которые вы подписались можно в <a href="/personal/subscription_list/">листе ожидания</a>.
                    </div>
                </div>
            `,
        );

        BX.Dom.addClass(this.rootNode, 'is-success');
    }

    handleSubscribeToProduct(context, event)
    {
        if (context.classList.contains('active')) {
            event.preventDefault();
            return;
        }

        const id = context.dataset.id;
        const offerId = context.dataset.offerId;

        context.classList.remove('active');
        $(context).button('loading');

        this.subscribeToProduct(id, offerId)
            .then(res => {
                $(context).button('reset');

                setTimeout(() => {
                    context.classList.add('active');
                    context.innerText = 'Добавлено';
                });

                BX.Event.EventEmitter.emit(
                    'Mario.Card:subscribed', 
                    { id, email: res.email, offer_id: offerId, source: 'basket' }
                );
            })
            .catch(() => {
                $(context).button('reset');
            })
    }

    subscribeToProduct(id, offerId)
    {
        return $.post('/ajax/subscribe/product/', { id, offer_id: offerId }, null, 'json')
            .then(res => {
                if (res.type !== 'success') {
                    throw new Error(res.error);
                }

                return res;
            });
    }

    getEntity(entityName, rootNode = null)
    {
        return (rootNode || this.rootNode).querySelector(`[data-entity="${entityName}"]`);
    }

    getAllEntities(entityName, rootNode = null)
    {
        return [...(rootNode || this.rootNode).querySelectorAll(`[data-entity="${entityName}"]`)];
    }
}